module.exports = __webpack_public_path__ + "img/noData.fe23dd60.png";